import React from "react";
import ReactDOM from "react-dom/client";

// Suppress benign ResizeObserver loop warning that CRA dev overlay treats as fatal
// Defer ResizeObserver callbacks a frame so Radix Select/Dialog never trigger the "ResizeObserver loop" dev overlay
const NativeRO = window.ResizeObserver;
if (NativeRO) {
  window.ResizeObserver = class extends NativeRO {
    constructor(cb) {
      super((entries, obs) => window.requestAnimationFrame(() => cb(entries, obs)));
    }
  };
}
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
